import React from "react";
import {
  Radio,
  FormControl,
  RadioGroup,
  FormLabel,
  FormControlLabel,
} from "@material-ui/core";

function Gender(props) {
  return (
    <FormControl>
      <FormLabel>성별</FormLabel>
      <RadioGroup
        row
        aria-label="gender"
        name="gender"
        variant="filled"
        value={props.gender}
        
        onChange={(e) => props.onChangeGender(e.target.value)}
      >
        <FormControlLabel disabled={props.SelfCertification} value="2" control={<Radio />} label="여성" />
        <FormControlLabel disabled={props.SelfCertification} value="1" control={<Radio />} label="남성" />
      </RadioGroup>
    </FormControl>
  );
}
export default Gender;
